import { createNextTableContext } from '@core/table';

export const TransactionsTableContext = createNextTableContext();
